import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";


export const fetchBookFormats = async ({ onSuccess, onError }) => {
    try {
        // const response = await fetchWithAuth(
        //     `${BACKEND_API_URL}/book-format`,
        //     { method: "GET" },
        //     auth
        // );
            const response = await fetch(
            `${BACKEND_API_URL}/book-format`,
            { method: "GET" }
        );

        const data = await handleApiResponse(response, "fetchBookFormats");

        if (onSuccess) onSuccess(data);
        return data;
    } catch (error) {
        if (onError) {
            onError(error);
            return;
        }
        throw error;
    }
};
